import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { darkTheme, FONT, GRAD } from '../../theme/tokens';
import { Avi } from '../ui/Avi';
import { SupportModeBanner } from '../support/SupportModeBanner';
import { SupportGrantList } from '../support/SupportGrantList';

// The staff landing (platform scope). Hosts the support-access org switcher
// (SC-2948); org/invite provisioning is separate future work.
// NOTE: ProtectedRoute currently only gates on isAuthenticated, not on
// isEkomAdmin — a non-admin who manually navigates to /admin will see this
// card. Acceptable for now since nothing surfaces /admin to non-admins, but a
// proper admin-role gate is coming with the post-demo admin work.
export function AdminLanding() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const t = darkTheme;

  return (
    <div style={{ minHeight: '100vh', background: t.bg, display: 'flex', flexDirection: 'column', fontFamily: FONT }}>
      {/* Where staff land after leaving a client org (SC-2948) — so a "support
          access ended" notice shows here. */}
      <SupportModeBanner />
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 440, background: t.surface, borderRadius: 12, padding: 32, border: `1px solid ${t.border}`, textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 20 }}>
            <Avi size={32} />
            <span style={{ background: GRAD, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 700, fontSize: 18 }}>EKOM</span>
          </div>
          <h2 style={{ color: t.text, margin: '0 0 8px', fontSize: 22, fontWeight: 600 }}>Admin Panel</h2>
          <p style={{ color: t.text2, fontSize: 14, lineHeight: 1.5, margin: '0 0 8px' }}>
            Welcome{user?.name ? `, ${user.name}` : ''}.
          </p>
          <p style={{ color: t.text3, fontSize: 13, lineHeight: 1.5, margin: '0 0 20px' }}>
            Enter a client organization you hold support access to.
          </p>
          {/* Staff land here in the platform scope, where the app shell can't load
              org data — so the org switcher lives here too, not only in the
              sidebar account menu (SC-2948). */}
          <div style={{ textAlign: 'left', marginBottom: 20 }}>
            <SupportGrantList variant="card" />
          </div>
          <button
            onClick={() => navigate('/')}
            style={{ width: '100%', padding: '10px 0', borderRadius: 8, border: 'none', background: GRAD, color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer', marginBottom: 12 }}
          >
            Continue to demo workspace →
          </button>
          <button
            onClick={() => { void logout(); }}
            style={{ width: '100%', padding: '10px 0', borderRadius: 8, border: `1px solid ${t.border}`, background: 'transparent', color: t.text2, fontWeight: 500, fontSize: 13, cursor: 'pointer' }}
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
